import React, { useState, useEffect, useContext } from "react";
import { IoIosClose } from "react-icons/io";
import "react-toastify/dist/ReactToastify.css";
import RequestService from "../../services/RequestService";
import MovementService from "../../services/MovementService";
import { parseISO, format } from "date-fns";
import { Context } from '../../context/UserContext'
import StatusRequests from '../../enums/StatusRequests'
import { getDescricaoByCod } from "../../enums/TiposGestao";


export default function RequestDetailsModalMobile({
  isModalOpen,
  setModalOpen,
  requestId,
  isGestao,
  // setTicketCb
}) {

  const [requestObject, setRequestObject] = useState();
  const [movements, setMovements] = useState([]);

  const [changeCodSapMode, setChangeCodSapMode] = useState(false)
  const [changeQtdAtender, setChangeQtdAtender] = useState(false)
  const [changeQtdCorte, setChangeQtdCorte] = useState(false)
  
  useContext(Context)

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      console.log(request?.request.idRequest);

      //get all log movements from this request
      const data = await MovementService.getMovementsFromRequest(requestId)

      setMovements(data.requestMovements);

    }

    fetchRequest();
  }, [isModalOpen, requestId, changeCodSapMode, changeQtdAtender, changeQtdCorte]);

  const onClose = () => {
    // setRequestObject(null)
    setModalOpen(!isModalOpen);
    setChangeCodSapMode(false)
    setChangeQtdAtender(false)
    setChangeQtdCorte(false)
  };

  const equipmentRows = (requestObject?.request?.equipamentos && requestObject?.request?.equipamentos.length > 0)
    ? requestObject.request.equipamentos
    : requestObject?.request
    ? [{
        _id: requestObject.request._id,
        codSap: requestObject.request.codSap,
        nomeEquipamento: requestObject.request.nomeEquipamento,
        partNumberEquipamento: requestObject.request.partNumberEquipamento,
        fabricanteEquipamento: requestObject.request.fabricanteEquipamento,
        quantidade: requestObject.request.quantidadeSolicitada,
      }]
    : [];


  if (isModalOpen) {
    return (
      <div
        className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-60"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="relative w-full max-w-md mx-auto my-4 bg-white rounded-xl shadow-lg overflow-y-auto max-h-[95vh]">
          {/* Botão de fechar */}
          <button
            onClick={onClose}
            className="absolute top-1 right-2 z-10 bg-white rounded-full shadow p-1"
            aria-label="Fechar"
          >
            <IoIosClose color={"black"} size={36} />
          </button>

          {/* Cabeçalho */}
          <div className="flex flex-col gap-1 px-4 pt-4 pb-2 bg-gray-800 text-white rounded-t-xl">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="flex gap-2 text-lg font-bold">
                <span>SOLICITAÇÃO</span>
                <span>#{requestObject?.request?.idRequest}</span>
              </div>
              {requestObject?.request?.isReplica && (
                <span className="text-xs font-bold rounded px-2 py-1 bg-yellow-300 text-black">
                  RÉPLICA SGRS
                </span>
              )}
            </div>
            <div className="flex flex-wrap gap-2 text-xs mt-1">
              <span>
                Criado em:{" "}
                {requestObject && format(parseISO(requestObject?.request?.createdAt), "dd/MM/yy HH:mm")}
              </span>
              <span>
                Atender até:{" "}
                {requestObject && format(parseISO(requestObject?.request?.slaDate), "dd/MM/yy HH:mm")}
              </span>
              <span className="flex items-center gap-1">
                Status:
                <span
                  className="text-black rounded px-2"
                  style={{
                    backgroundColor: StatusRequests[requestObject?.request?.status]?.cor,
                  }}
                >
                  {requestObject?.request?.status}
                </span>
              </span>
            </div>
          </div>

          {/* Conteúdo */}
          <div className="flex flex-col gap-3 px-4 py-3 text-xs">

            {/* Solicitante */}
            <div className="bg-gray-50 border rounded-lg p-3">
              <div className="font-semibold text-gray-700 mb-1">Solicitante</div>
              <div><span className="font-semibold">Nome:</span> {requestObject?.request?.nomeSolicitante}</div>
              <div><span className="font-semibold">RE/Legal:</span> {requestObject?.request?.reLegalSolicitante}</div>
              <div><span className="font-semibold">UF:</span> {requestObject?.request?.uf}</div>
              <div><span className="font-semibold">Empresa:</span> {requestObject?.request?.empresaSolicitante}</div>
            </div>

            {/* Equipamento */}
            <div className="bg-gray-50 border rounded-lg p-3">
              <div className="font-semibold text-gray-700 mb-2">Equipamento</div>
              <div className="flex flex-col gap-2">
                {equipmentRows.map((equipment, index) => (
                  <div key={equipment._id || `${equipment.codSap}-${equipment.partNumberEquipamento}-${index}`} className="rounded-md border border-zinc-300 bg-white p-2 shadow-sm">
                    <div><span className="font-semibold">Cod. SAP:</span> {equipment.codSap}</div>
                    <div><span className="font-semibold">Nome:</span> {equipment.nomeEquipamento}</div>
                    <div><span className="font-semibold">Part Number:</span> {equipment.partNumberEquipamento}</div>
                    <div><span className="font-semibold">Fabricante:</span> {equipment.fabricanteEquipamento}</div>
                    <div><span className="font-semibold">Qtd:</span> {equipment.quantidade}</div>
                  </div>
                ))}

                {requestObject?.request?.codSapAlternativo && (
                  <div className="text-blue-500">
                    <span className="font-semibold">*SAP alternativo:</span> {requestObject?.request?.codSapAlternativo}
                  </div>
                )}

                <div className="overflow-hidden rounded-md border border-zinc-300 bg-white shadow-sm">
                  <table className="min-w-full text-[10px] text-left text-gray-700">
                    <thead className="bg-gray-200">
                      <tr>
                        <th colSpan="2" className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-600 bg-zinc-100 border-b border-zinc-300">
                          Quantidades
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-t border-zinc-200 align-middle">
                        <td className="px-2 py-1 font-bold text-gray-700">Qtd Solicitada</td>
                        <td className="px-2 py-1 text-center">{requestObject?.request?.quantidadeSolicitada}</td>
                      </tr>
                      <tr className="border-t border-zinc-200 align-middle">
                        <td className="px-2 py-1 font-bold text-gray-700">Qtd Cortada</td>
                        <td className="px-2 py-1 text-center">{requestObject?.request?.quantidadeCortada}</td>
                      </tr>
                      <tr className="border-t border-zinc-200 align-middle">
                        <td className="px-2 py-1 font-bold text-gray-700">Qtd a Atender</td>
                        <td className="px-2 py-1 text-center">{requestObject?.request?.quantidadeAtender}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Boleto */}
            <div className="bg-gray-50 border rounded-lg p-3">
              <div className="font-semibold text-gray-700 mb-1">Boleto</div>
              <div><span className="font-semibold">Identificação:</span> {requestObject?.request?.idBoleto}</div>
              <div><span className="font-semibold">Tipo:</span> {requestObject?.request?.tipoBoleto?.toUpperCase()}</div>
              <div><span className="font-semibold">Tipo Atendimento:</span> {requestObject?.request?.tipoAtendimento?.toUpperCase()}</div>
            </div>

            {/* Site/Entrega */}
            <div className="bg-gray-50 border rounded-lg p-3">
              {/* <div className="font-semibold text-gray-700 mb-1">Entrega</div> */}
              <div><span className="font-semibold">Site:</span> {requestObject?.request?.site}</div>
              <div><span className="font-semibold">GMO:</span> {requestObject?.request?.gmo?.cidade}{requestObject?.request?.gmo?.identificador ? ` - ${requestObject?.request?.gmo?.identificador}` : ""}</div>
              <div><span className="font-semibold">DRS Original:</span> {requestObject?.request?.drsOriginal?.sigla}</div>
              <div><span className="font-semibold">DRS Atender:</span> {requestObject?.request?.drsAtender?.sigla || "-"}</div>
              <div><span className="font-semibold">Endereço GMO:</span> {requestObject?.request?.gmo?.endereco}</div>
              <div><span className="font-semibold">Cidade GMO:</span> {requestObject?.request?.gmo?.cidade}</div>
            </div>

            {/* Contato Técnico */}
            <div className="bg-gray-50 border rounded-lg p-3">
              <div className="font-semibold text-gray-700 mb-1">Técnico/Entrega</div>
              <div><span className="font-semibold">RE Técnico:</span> {requestObject?.request?.reTecnico}</div>
              <div><span className="font-semibold">Nome:</span> {requestObject?.request?.tecnico}</div>
              <div><span className="font-semibold">Empresa:</span> {requestObject?.request?.empresaTecnico?.socialName}</div>
              <div><span className="font-semibold">Telefone:</span> {requestObject?.request?.telefone}</div>
              <div><span className="font-semibold">Endereço Entrega:</span> {requestObject?.request?.enderecoEntrega}</div>
              <div><span className="font-semibold">Cidade Entrega:</span> {requestObject?.request?.cidadeEntrega}</div>
              <div><span className="font-semibold">Complemento:</span> {requestObject?.request?.enderecoEntregaComplemento}</div>
            </div>

            {/* Código de Barras */}
            {requestObject?.request?.codItemsAtendidos?.length > 0 && (
              <div className="bg-gray-50 border rounded-lg p-3">
                <div className="font-bold text-gray-700 mb-1">Código de Barras</div>
                <div className="flex flex-col gap-1 max-h-32 overflow-y-auto bg-white border border-zinc-300 rounded-md p-2">
                  {requestObject.request.codItemsAtendidos.map((item, idx) => (
                    <div key={idx} className="text-xs text-gray-700">
                      <span className="font-semibold">#{idx + 1}:</span> {item}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Motivo Gestão */}
            {isGestao && (
              <div className="bg-red-100 border rounded-lg p-3">
                <div className="font-semibold text-gray-700 mb-1">Motivo Gestão</div>
                <div>
                  {requestObject?.request?.motivoEnvioGestao} - {getDescricaoByCod(requestObject?.request?.motivoEnvioGestao)}
                </div>
              </div>
            )}

            {/* Observações */}
            <div className="bg-gray-50 border rounded-lg p-3">
              <div className="font-semibold text-gray-700 mb-1">Observação do solicitante</div>
              <div className="text-xs whitespace-pre-line">{requestObject?.request?.observacao}</div>
            </div>
            <div className="bg-gray-50 border rounded-lg p-3">
              <div className="font-semibold text-gray-700 mb-1">Última observação</div>
              <div className="text-xs whitespace-pre-line">{requestObject?.request?.ultimaObs}</div>
            </div>

            {/* Movimentações */}
            {movements.length !== 0 && (
              <div className="bg-gray-50 border rounded-lg p-3">
                <div className="font-bold text-gray-700 mb-2">Movimentações</div>
                <div className="flex flex-col gap-2 max-h-48 overflow-y-auto">
                  {movements.slice().reverse().map((movement) => (
                    <div
                      key={movement._id}
                      className="bg-white rounded-lg border border-gray-200 p-2 flex flex-col text-xs shadow"
                    >
                      <div className="flex flex-wrap gap-x-2 gap-y-1 mb-1">
                        <div>
                          <span className="font-semibold text-gray-700">Data:</span>
                          <span className="ml-1">{format(parseISO(movement.createdAt), 'dd/MM/yy HH:mm')}</span>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-700">Usuário:</span>
                          <span className="ml-1">{movement.user.userName}</span>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-x-2 gap-y-1 mb-1">
                        <div>
                          <span className="font-semibold text-gray-700">Status:</span>
                          <span className="ml-1">{movement.oldStatus}</span>
                          <span className="mx-1 text-gray-400">{'>>'}</span>
                          <span className="font-semibold">{movement.newStatus}</span>
                        </div>
                      </div>
                      <div className="flex flex-col gap-1">
                        <div>
                          <span className="font-semibold text-gray-700">Obs:</span>
                          <span className="ml-1">{movement.obsAtualizacao ? movement.obsAtualizacao : '-'}</span>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-700">Carimbo:</span>
                          <span className="ml-1">{movement.carimbo ? movement.carimbo : '-'}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}
